import { useSelector } from 'react-redux';
import { RootState } from '../../../services/store';

export default function useAILogs() {
	const { items, loading } = useSelector((store: RootState) => store.aiLogs);

	return {
		items,
		loading,
	};
}
